import { Component, OnInit, ViewChild } from '@angular/core';
import { BnplService } from '../../shared/services/bnpl.service';
import { Observable } from 'rxjs';
import { ControlBase } from 'src/app/core/shared/models/control-base';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { NavigationExtras, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { IdentityvalidationService } from '../../shared/services/identityvalidation.service';
import { OtherOtp } from '../../shared/models/other-otp.model';
import { DataInformation } from '../../shared/models/data-information.model';
import { FormComponent } from 'src/app/core/components/form/form.component';
import { AuthorizatioData } from '../../shared/models/authorization.model';

@Component({
  selector: 'app-confirm-otp',
  templateUrl: './confirm-otp.component.html',
  styleUrls: ['./confirm-otp.component.css'],
})
export class ConfirmOtpComponent implements OnInit {
  @ViewChild(FormComponent) appFormComponent!: FormComponent;
  public controlsOtp$: Observable<ControlBase<any>[]>;
  public mostrarNuevoCodigo: boolean = false;
  public mostrarError: boolean = false;
  public dataInformation: DataInformation;
  public timesCircle = faTimesCircle;
  public checkCircle = faCheckCircle;
  public otp: any;
  navigationExtras: NavigationExtras = {}
  constructor(
    private readonly bnplService: BnplService,
    private readonly validationStrategyService: IdentityvalidationService,
    private readonly router: Router
  ) {
    this.dataInformation = this.bnplService.personalInformation;
    this.controlsOtp$ = this.bnplService.getOtpControls();
  }
  ngOnInit(): void {
    Swal.close();
  }

  getConfirmOtp({ otp }: any) {
    this.bnplService.alertWait()
    let data = {
      actionStrategyPattern: 'VALIDATE_STRATEGY',
      id: this.bnplService.personalInformation.id || localStorage.getItem('id'),
      otp: otp,
      validationStrategy: {
        validationStrategy: 'RECONOCER',
      },
    };
    this.validationStrategyService.postPreguntasEvidente(data).subscribe({
      next: (resp: any) => {
        this.navigationExtras = { state: resp }
        if (resp.validationStrategy === 'CREDIT_APPROVED') {
          
          this.bnplService.creditEmit = resp;
          localStorage.setItem('fun', 'S')
          this.router.navigate(['/await-alert', 'ultimopaso']);
          Swal.close();
        }

        if (resp.validationStrategy === 'OK') {
          this.bnplService.creditEmit = resp;
          this.router.navigate(['/usecupo']);
        }

        if (resp.showMessage == 1) {
          this.appFormComponent.resetForm();
          Swal.close();
          this.bnplService.openSnack(resp)
        }

        if (resp.showMessage == 2) {
          Swal.close();
          this.router.navigate(['/await-alert', 'error'], this.navigationExtras);
        }

        if (resp.errorMessage) {
          this.router.navigate(['/await-alert', 'error-connection']);
        }
      },
      error: (e: any) => {
        Swal.close();
        this.router.navigate(['/await-alert', 'error-connection']);
        console.log('error', e)
      },
    });
  }




  enviarNuevoOtp() {
    let data: OtherOtp = {
      id: this.bnplService.personalInformation.id || localStorage.getItem('id') || "",
      actionStrategyPattern: 'RESEND_OTP_APR',
    };
    this.validationStrategyService
      .getOtherOtp(data)
      .subscribe({
        next: (resp: any) => {
          this.mostrarError = false;
          if (resp.validationStrategy === 'SEND_OTP') {
            this.mostrarNuevoCodigo = true;
            setTimeout(() => {
              this.mostrarNuevoCodigo = false;
            }, 5000);
          }

          if (resp.errorMessage) {
            this.router.navigate(['/await-alert', 'error-connection']);
          }
        },
        error: (e: any) => {
          Swal.close();
          this.router.navigate(['/await-alert', 'error-connection']);
          console.log('error', e)
        }
      })
  }
}

// DRUO LOGICA 
// import { ResponseCreateUserDruo } from '../../shared/models/druo.model';

// try {
//   this.getDataDruo().subscribe((res: any) => {

//     if ((res.id && res.id != '') || (res.uuid && res.uuid != '')) {
//       this.bnplService.druo = res;
//     }

//     if (res.exists == 'S') {
//       this.bnplService.druo.exists = 'S'
//     }
//     this.bnplService.creditEmit = resp;
//     localStorage.setItem('fun', 'S')
//     this.router.navigate(['/await-alert', 'ultimopaso']);
//     Swal.close();
//   })
// } catch (error) {

// }

// getDataDruo() {
//   const datauser = this.bnplService.stepsInformation.secondStep
//   let data = {
//     "action": "CREATE_USER",
//     "email": datauser.email,
//     "name": datauser.primerNombre,
//     "lastName": datauser.primerApellido,
//     "type": "INDIVIDUAL",
//     "numberId": this.bnplService.stepsInformation.firstStep.numeroDocumento,
//     "cellphone": this.bnplService.stepsInformation.firstStep.celular,
//   }
//   return this.validationStrategyService.setDataDruo(data)
// }


// try {
//   this.bnplService.stepsInformation.secondStep.primerNombre = res.names
//   this.bnplService.stepsInformation.secondStep.primerApellido = res.lastName
//   this.bnplService.stepsInformation.secondStep.email = res.email
//   this.bnplService.stepsInformation.firstStep.celular = res.cellphone
//   this.bnplService.stepsInformation.firstStep.numeroDocumento = res.numberId
//   this.getDataDruo().subscribe((res: any) => {
//     if (res.id && res.id != '') {
//       this.bnplService.druo = res
//     }

//     if (res.exists == 'S') {
//       this.bnplService.druo.exists = 'S'
//     }

//     this.bnplService.creditEmit = resp;
//     this.router.navigate(['/usecupo']);
//   })
// } catch (error) {

// }

// const DataAuthorization = {
//   "actionStrategyPattern": "GET_DATA_AUTHORIZATION",
//   "identificacion": this.bnplService.personalInformation.identificacion || this.bnplService.stepsInformation.firstStep.numeroDocumento,
// }

// this.bnplService.getDataAuthorization(DataAuthorization).subscribe((res: AuthorizatioData) => {
//   if (res != null) {
   
    
//   }
// })